module.exports = __webpack_public_path__ + "static/samuel-41be4867cda5bbf978bcc72aee6e35a0.png";